import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Store pro produkt "Měřené veličiny" (/station-group/meas-*) — viz doc/plans/station-group-meas.md
// sekce 4a-i. Potvrzení gate ("zobrazit i přesto") se záměrně NEUKLÁDÁ sem/do sessionStorage —
// drží se jako lokální React state přímo v MeasGrafTable, aby při jakékoli změně skupiny/filtrů
// (a tedy nodes) zmizelo automaticky spolu s překreslením komponenty, bez nutnosti dopočítávat a
// invalidovat klíč podle aktuální množiny stanic.
//
// windowDays/alignEnd/isAktual/chartFormat/interactive jsou zde jen pro granKey==='10m' — HLY a DLY
// mají vlastní oddělené store (useHlyMeasStore/useDlyMeasStore), stejně jako u jedné stanice
// (useGrafStore vs. useHlyGrafStore vs. useDlyGrafStore), aby přepnutí granularity/veličiny
// nepřeneslo nastavení (počet dní, aktuální, formát) z jedné granularity do druhé.
export const useMeasStore = create(
  persist(
    set => ({
      activeTab: 'graf',
      // Pozn.: „Popisek stanice" (labelFields) je nově globální — useStationLabelStore
      // (sdílené přes celou aplikaci, ne per-produkt).

      // 10m graf skupin stanic — stejná ovládací sada jako GrafHeaderMin u jedné stanice
      windowDays: 1,
      alignEnd: true,
      isAktual: false,
      chartFormat: 'png',
      interactive: false,

      setActiveTab: activeTab => set({ activeTab }),
      setWindowDays: windowDays => set({ windowDays }),
      setAlignEnd: alignEnd => set({ alignEnd }),
      setIsAktual: isAktual => set({ isAktual }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'meas-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)

// HLY graf skupin stanic — oddělený od 10m (viz komentář výše), stejná ovládací sada jako
// useHlyGrafStore u jedné stanice.
export const useHlyMeasStore = create(
  persist(
    set => ({
      windowDays: 1,
      alignEnd: true,
      isAktual: false,
      chartFormat: 'png',
      interactive: false,

      setWindowDays: windowDays => set({ windowDays }),
      setAlignEnd: alignEnd => set({ alignEnd }),
      setIsAktual: isAktual => set({ isAktual }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'hly-meas-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)

// DLY graf skupin stanic — oddělený od 10m/HLY (viz komentář výše), stejná ovládací sada jako
// useDlyGrafStore u jedné stanice.
export const useDlyMeasStore = create(
  persist(
    set => ({
      isAktual: false,
      chartFormat: 'png',
      interactive: false,

      setIsAktual: isAktual => set({ isAktual }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'dly-meas-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
